// extracted by mini-css-extract-plugin
export default {"active-invoice-filters":"SearchFilter_active-invoice-filters__gKqTl"};